//登録フロー：利用規約同意 /newflow8
import React, {Component} from 'react';
import Header from './header'
import Footer from './footer'
import users from './store/user'
import {Link, browserHistory} from 'react-router'
import ToggleDisplay from 'react-toggle-display';
import {checkLogin, termsCheckregister, registComplete} from './firebase'
import './css/newflow8.css';
import './css/terms.css';
import 'rc-checkbox/assets/index.css';

export default class App extends Component {

  constructor() {
    super();
    this.state = {
      showTerms: false,
      isTerms: false,
      checkClass: "rc-checkbox"
    };
  }

// モーダルを開く
  openModal = (e) => {
    e.preventDefault()
    this.refs['footer'].setState({modalIsOpen: true});
  }

  // 利用規約に同意チェック
  termsOn(e) {
    if (true === this.state.isTerms) {
      this.setState({ isTerms: false });
      this.setState({ checkClass: "rc-checkbox" });
      users.getMyUser().termsCheck = ""
    } else {
      this.setState({ isTerms: true });
      this.setState({ checkClass: "rc-checkbox rc-checkbox-checked" });
      users.getMyUser().termsCheck = "true"
    }
  }

  registComplete(e) {
    e.preventDefault()    
    termsCheckregister("true")
    registComplete("true")
    browserHistory.push("/newflow10");
  }

  // onload
  componentDidMount() {
    // ログインチェック
    checkLogin()
  }

render(){
  return (
    <div id="wrapper">
      <div id="" className="wrapper-lp wrapper-newflow8">
        <Header parentProps={this.props} />
        <div className="webWrap">
          <div className="wrapCover">
            <div className="wrapCover__contentBlock clearfix">
              <div className="content-top">
                <div className="block-newflow8">
                  <h2 className="title">Sign Up</h2>
                  <img className="step_icon" src="/img/common/step-6@2x.png" alt="" />
                  <img className="title_icon" src="/img/common/img_document.png" alt="" />
                  <p className="subtitle">確認して登録</p>
                  <form className="form-tel">
                    <label>
                      <label><span className={this.state.checkClass}><input className="rc-checkbox-input" type="checkbox" name="my-checkbox" onChange={(e) => {this.termsOn(e)}} /><span className="rc-checkbox-inner"></span></span>
                      &nbsp;&nbsp;<Link onClick={this.openModal} className="terms-link">利用規約</Link>に同意します。</label>
                    </label>
                  </form>
                  <div className="btnAction">
                    <ToggleDisplay if={this.state.isTerms}>
                      <Link onClick={(e) => {this.registComplete(e)}} className="btn-connect">登録</Link>
                    </ToggleDisplay>
                    <ToggleDisplay if={!this.state.isTerms}>
                      <Link className="btn-connect disabled">登録</Link>
                    </ToggleDisplay>
                  </div>
                  
                </div>
              </div>
            </div>
            <Footer ref="footer" />
          </div>
        </div>
      </div>

    </div>
  )
}

}




// WEBPACK FOOTER //
// ./src/newflow8.js